export default __webpack_public_path__ + "f482b077202f64a3c71ad733c740b9e5.png";